export default "__VITE_ASSET__Bsc3KSyL__"